import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Users, Laptop, Dumbbell, Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Services() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: Dumbbell,
    title: t.services.personal.title,
    description: t.services.personal.description,
    features: t.services.personal.features,
    price: t.services.personal.price,
    highlight: true
  }, {
    icon: Users,
    title: t.services.group.title,
    description: t.services.group.description,
    features: t.services.group.features,
    price: t.services.group.price,
    highlight: false
  }, {
    icon: Laptop,
    title: t.services.online.title,
    description: t.services.online.description,
    features: t.services.online.features,
    price: t.services.online.price,
    highlight: false
  }];
  return <Section id="services" data-id="element-144">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-145">
        <h2 className="font-display text-5xl md:text-6xl text-white mb-4" data-id="element-146">
          {t.services.title}{' '}
          <span className="text-brand-accent" data-id="element-147">{t.services.titleAccent}</span>
        </h2>
        <p className="text-gray-400 text-lg" data-id="element-148">{t.services.subtitle}</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-149">
        {services.map((service, index) => <div key={index} className={`relative p-8 flex flex-col h-full transition-all duration-300 hover:-translate-y-2 ${service.highlight ? 'bg-brand-surface border-2 border-brand-accent' : 'bg-brand-dark border border-white/10 hover:border-brand-accent/50'}`} data-id="element-150">
            {service.highlight && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-accent text-brand-dark text-xs font-bold uppercase tracking-widest py-1 px-4 rounded-full" data-id="element-151">
                {t.services.mostPopular}
              </div>}

            <div className="w-14 h-14 bg-brand-gray rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-accent transition-colors" data-id="element-152">
              <service.icon className={`w-7 h-7 ${service.highlight ? 'text-brand-accent' : 'text-white'} group-hover:text-brand-dark transition-colors`} data-id="element-153" />
            </div>

            <h3 className="font-display text-3xl text-white mb-3" data-id="element-154">
              {service.title}
            </h3>
            <p className="text-gray-400 mb-8 flex-grow" data-id="element-155">
              {service.description}
            </p>

            <ul className="space-y-4 mb-8" data-id="element-156">
              {service.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-157">
                  <Check className="w-5 h-5 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-158" />
                  <span className="text-gray-300 text-sm" data-id="element-159">{feature}</span>
                </li>)}
            </ul>

            <div className="mt-auto" data-id="element-160">
              <p className="text-white font-bold text-lg mb-4" data-id="element-161">
                {service.price}
              </p>
              <Button variant={service.highlight ? 'primary' : 'outline'} className="w-full" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-162">
                {t.services.getStarted}
              </Button>
            </div>
          </div>)}
      </div>
    </Section>;
}